<div class="flex items-center gap-1 bg-white border border-gray-300 rounded-lg w-full sm:w-fit overflow-x-auto" [ngClass]="{'pointer-events-none opacity-50': disabled}">
  <ng-container *ngFor="let tab of tabs; let i = index">
    <button class="px-4 sm:px-6 md:px-10 py-2 text-xs sm:text-sm font-medium rounded-lg transition-all duration-200 capitalize whitespace-nowrap" [ngClass]="{
        'bg-[#EEF0FF] text-primary border border-primary shadow-sm text-sm font-medium': activeTab === tab.name,
        'text-gray-500 hover:text-gray-700 text-sm font-normal': activeTab !== tab.name
      }" (click)="selectTab(tab)" [disabled]="disabled">
      {{ tab.label || tab.name }}
    </button>
    <!-- Divider -->
    <div *ngIf="i < tabs.length - 1" class="hidden sm:block w-[1px] h-6 bg-gray-300 mx-1 sm:mx-2"></div>
  </ng-container>
</div>